import { render } from "./Home.page.vue?vue&type=template&id=b1f1d7d4&ts=true"
import script from "./Home.page.vue?vue&type=script&lang=ts"
export * from "./Home.page.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__